import { render, staticRenderFns } from "./InfosetsReborn.vue?vue&type=template&id=2688d3d0&scoped=true&"
import script from "./InfosetsReborn.vue?vue&type=script&lang=ts&"
export * from "./InfosetsReborn.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsReborn.vue?vue&type=style&index=0&id=2688d3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688d3d0",
  null
  
)

export default component.exports